import React, {Component} from 'react'

class Help008 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />メールアドレスを変更する</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[8-1]</span>画面上部のメニューの中の「個人設定」の「メールアドレス変更」(図8-1 参照)を押してください。</legend>
              <figcaption>図8-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_8-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[8-2]</span>画面の中の「新しいメールアドレス」と「新しいメールアドレス(確認用)」を入力して、「メールアドレスを変更する」ボタン(図8-2 参照)を押してください。</legend>
              <figcaption>図8-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_8-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[8-3]</span>メッセージが表示されるので「OK」ボタンを押してください。(図8-3 参照)</legend>
              <figcaption>図8-3</figcaption>
              <ul>
                <li><img alt='' src='/help/help_8-3.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default Help008



// WEBPACK FOOTER //
// ./src/help/Help008.js